module.exports = __webpack_public_path__ + "static/media/bonilla_oliver_reid.1b922393.jpg";